<template>
  <section class="section">
    <div class="container no-print">
      <div class="columns">
        <div class="column">
          <h2 class="title">
            Department of Agri Product Sale and Marketing/ B2B Contract Purchase
          </h2>
        </div>
      </div>
      <b-tabs v-model="activeTab" v-if="roleid == 6 || roleid == 7">
        <b-tab-item label="B2B">
          <div class="columns scrollme">
            <div class="column">
              <b-filed>
                <b-field group>
                  <b-field label="ຄວາມຕ້ອງການຕາມ B2B (ແຜນຈັດຊື້)"></b-field>
                  <b-field style="margin: 0 10px 0 10px;">
                    <router-link to="/dasm/setting/b2buser">
                      <b-button
                        class="btn-group-margin"
                        type="is-primary"
                        size="is-small"
                        >ຈັດການ B2B
                      </b-button>
                    </router-link>
                  </b-field>
                </b-field>

                <table class="table is-fullwidth is-narrow is-small">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>
                      <th class="has-text-left " width="15%">
                        ຊື່ B2B
                      </th>
                      <th class="has-text-left " width="15%">
                        ແຂວງ
                      </th>
                      <th class="has-text-left " width="15%">
                        ເມືອງ
                      </th>
                      <th class="has-text-left " width="30%">
                        ບ້ານ
                      </th>
                      <th class="has-text-left " width="30%">
                        ຈຳນວນສັນຍາ
                      </th>
                      <th class="has-text-left " width="10%">
                        ຈັດການ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data, index) in activeb2b" :key="data.USERID">
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ data.FULLNAME }}
                      </td>
                      <td>
                        {{ data.PROVINCENAME }}
                      </td>
                      <td>
                        {{ data.DISTRICT }}
                      </td>
                      <td>
                        {{ data.VILLAGE }}
                      </td>
                      <td class="has-text-right">
                        {{ data.COUNTCONTRACT }}
                      </td>

                      <td class="has-text-centered">
                        <b-field group>
                          <b-field>
                            <b-button
                              class="btn-group-margin"
                              type="is-primary"
                              size="is-small"
                              @click="contractform(data.USERID, data.USERNAME)"
                              >ຟອມສັນຍາ
                            </b-button>
                          </b-field>
                        </b-field>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-filed>
            </div>
          </div>
        </b-tab-item>

        <b-tab-item label="ຟອມສັນຍາ">
          <b-field v-if="b2busername === null">
            <button class="button is-info" @click="gotoB2Blist">
              ເລືອກ B2B
            </button>
          </b-field>
          <b-filed v-else>
            <div class="columns">
              <div class="column">
                <h3 class="title">{{ b2busername }}</h3>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <b-field label="ຟອມສັນຍາ (ແຜນຈັດຊື້)"></b-field>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <div class="columns">
                  <div class="column">
                    ສັນຍາຫຼັກເລກທີ <span class="asterisk">*</span>
                    <b-field label="">
                      <b-input v-model.trim="contractno"> </b-input>
                    </b-field>
                  </div>
                  <div class="column">
                    ສັນຍາຍ່ອຍເລກທີ <span class="asterisk">*</span>
                    <b-field label="">
                      <b-input v-model.trim="subcontractno"> </b-input>
                    </b-field>
                  </div>
                  <div class="column">
                    ວັນທີສັນຍາ
                    <b-field>
                      <b-datepicker
                        :date-formatter="dateFormatter"
                        v-model="selecteddate"
                        @input="onSelecteddate"
                      >
                      </b-datepicker>
                    </b-field>
                  </div>
                  <div class="column">
                    ລາຍລະອຽດ
                    <b-field label="">
                      <b-input v-model.trim="contractdetail"> </b-input>
                    </b-field>
                  </div>
                </div>

                <div class="columns">
                  <div class="column">
                    ປະເທດ <span class="asterisk">*</span>
                    <b-field label="">
                      <Multiselect
                        placeholder="ເລືອກ"
                        v-model.trim="SelectedCountry"
                        label="NAME"
                        track-by="ID"
                        :options="countryList"
                        @input="onCountrySelected"
                      >
                      </Multiselect>
                    </b-field>
                  </div>
                  <div class="column">
                    ແຂວງ <span class="asterisk">*</span>
                    <b-field label="">
                      <Multiselect
                        placeholder="ເລືອກ"
                        v-model.trim="SelectedProvince"
                        label="NAME"
                        track-by="ID"
                        :options="ProvinceList"
                      >
                      </Multiselect>
                    </b-field>
                  </div>
                  <div class="column">
                    ເມືອງ <span class="asterisk">*</span>
                    <b-field label="">
                      <b-input v-model.trim="district"> </b-input>
                    </b-field>
                  </div>
                  <div class="column">
                    ບ້ານ <span class="asterisk">*</span>
                    <b-field label="">
                      <b-input v-model.trim="village"> </b-input>
                    </b-field>
                  </div>
                </div>

                <b-field label="" style="float: right">
                  <b-field v-if="saveAction">
                    <button class="button is-info" @click="saveContract">
                      ບັນທຶກ
                    </button>
                  </b-field>
                  <b-field v-if="updateAction">
                    <div class="columns">
                      <div class="column">
                        <b-field>
                          <button
                            class="button is-primary"
                            @click="updateFarmer"
                          >
                            ແກ້ໄຂ
                          </button>
                        </b-field>
                      </div>
                      <div class="column">
                        <b-field>
                          <button
                            class="button is-info"
                            @click="openSaveFarmerForm"
                          >
                            ຟອມເພີ່ມສັນຍາ
                          </button>
                        </b-field>
                      </div>
                    </div>
                  </b-field>
                </b-field>
              </div>
            </div>

            <b-field>
              <b-tabs v-model="activeQuotaProgressTab">
                <b-tab-item label="Prepare">
                  <table class="table is-fullwidth is-narrow is-small">
                    <thead>
                      <tr>
                        <th class="has-text-centered " width="5%">#</th>
                        <th class="has-text-left " width="10%">
                          ສັນຍາເລກທີ/ <br />ເລກທີຍ່ອຍ
                        </th>
                        <th class="has-text-left " width="10%">
                          ວັນທີສັນຍາ
                        </th>
                        <th class="has-text-left " width="10%">
                          ຈຳນວນ<br />ວັນສົ່ງສິນຄ້າ
                        </th>
                        <th class="has-text-left " width="25%">
                          ສະຖານທີ່ຮັບສິນຄ້າ
                        </th>
                        <!-- <th class="has-text-left " width="10%">
                            ລາຍລະອຽດ
                          </th> -->
                        <th class="has-text-centered " width="10%">
                          ສະຖານະ
                        </th>
                        <th class="has-text-centered " width="20%">
                          ຈັດການ
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(data, index) in contractlist_waittoapprove" 
                        :key="data.ID"
                      >
                        <td class="has-text-centered" v-if="data.COUNTDATE>0 ">{{ index + 1 }}</td> 
                        <td v-if="data.COUNTDATE>0 ">{{ data.CONTRACTNO }}/ {{ data.SUBCONTRACTNO }}</td> 
                        <td v-if="data.COUNTDATE>0 ">
                          {{ dateFormatter(data.CONTRACTDATE) }} 
                        </td>
                        <td v-if="data.COUNTDATE>0 ">
                          {{ data.COUNTDATE }} /  {{ data.COUNTALLDATE }}
                        </td>
                        <td v-if="data.COUNTDATE>0 ">
                          {{ data.PROVINCENAME }} {{ data.DISTRICT }}
                          {{ data.VILLAGE }}
                        </td>
                        <!-- <td>
                            {{ data.DETAIL }}
                          </td> -->
                        <td class="has-text-centered" v-if="data.COUNTDATE>0 ">
                          <b-field v-if="data.STATUS == 1">
                            <b-button type="is-warning" size="is-small"
                              >ລໍຖ້າຢືນຢັນ
                            </b-button>
                          </b-field>
                          <b-field v-else-if="data.STATUS == 2">
                            <b-button type="is-warning" size="is-small"
                              >ລໍຖ້າອອກໃບຮຽກເກັບ
                            </b-button>
                          </b-field>
                          <b-field v-else-if="data.STATUS == 3">
                            <b-button type="is-warning" size="is-small"
                              >ລໍຖ້າຊຳລະເງິນ
                            </b-button>
                          </b-field>
                          <b-field v-else-if="data.STATUS == 4">
                            <b-button type="is-infor" size="is-small"
                              >ຊຳລະເງິນແລ້ວ
                            </b-button>
                          </b-field>
                        </td>

                        <td class="has-text-centered" v-if="data.COUNTDATE>0 ">
                          <b-field group>
                            <b-field>
                              <b-button
                                class="btn-group-margin"
                                type="is-info"
                                size="is-small" 
                                @click="
                                  quotadetailform(
                                    data.ID,
                                    data.B2BUSERNAME,
                                    data.CONTRACTNO,
                                    data.SUBCONTRACTNO,
                                    data.CONTRACTDATE,
                                    data.SELECTEDDPPBRANCHID,
                                    data.SELECTEDDPPPROVINCE,
                                    data.STATUS
                                  )
                                "
                                >ລາຍລະອຽດ
                              </b-button>
                            </b-field>
                            <!-- <b-field v-if="data.STATUS ==1">
                              <b-button 
                                class="btn-group-margin"
                                type="is-primary"
                                size="is-small"
                                @click="
                                  quotadetailform(
                                    data.ID
                                  )
                                "
                                >ຢືນຢັນລາຍການ
                              </b-button>
                            </b-field> -->
                            <b-field v-if="data.STATUS ==2">
                              <b-button 
                                class="btn-group-margin"
                                type="is-primary"
                                size="is-small"
                                @click="
                                  quotadetailform(
                                    data.ID
                                  )
                                "
                                >ອອກໃບເກັບເງິນ
                              </b-button>
                            </b-field>
                            <b-field v-else-if="data.STATUS ==3">
                              <b-button 
                                class="btn-group-margin"
                                type="is-primary"
                                size="is-small"
                                @click="
                                  quotadetailform(
                                    data.ID
                                  )
                                "
                                >ຢືນຢັນການເກັບເງິນ
                              </b-button>
                            </b-field>
                          </b-field>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-tab-item>
                <b-tab-item label="Quotation">
                  <table class="table is-fullwidth is-narrow is-small">
                    <thead>
                      <tr>
                        <th class="has-text-centered " width="5%">#</th>
                        <th class="has-text-left " width="10%">
                          ສັນຍາເລກທີ/ <br />ເລກທີຍ່ອຍ
                        </th>
                        <th class="has-text-left " width="10%">
                          ວັນທີສັນຍາ
                        </th>
                        <th class="has-text-left " width="15%">
                          ວັນທີສົ່ງສິນຄ້າ
                        </th>
                        <th class="has-text-left " width="15%">
                          ປະເພດ
                        </th>
                        <th class="has-text-left " width="15%">
                          ສິນຄ້າ
                        </th>
                        <th class="has-text-centered " width="15%">
                          ຈັດການ
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(data, index) in contractlist_waitinvoice"
                        :key="data.REDATE"
                      >
                        <td class="has-text-centered">{{ index + 1 }}</td>
                        <td>{{ data.CONTRACTNO }}/ {{ data.SUBCONTRACTNO }}</td>
                        <td>
                          {{ dateFormatter(data.CONTRACTDATE) }}
                        </td>
                        <td>
                          {{ dateFormatter(data.REDATE) }}
                        </td>
                        <td>
                          {{ data.COUNTTYPE }}
                        </td>
                        <td>
                          {{ data.COUNTPRODUCT }} / {{ data.COUNTPRODUCTSUB }}
                        </td>
                        <td class="has-text-centered">
                          <b-button
                            class="btn-group-margin"
                            type="is-info"
                            size="is-small"
                            @click="openContractDateForm({'B2BID':data.B2BID,'PURCHASEID':data.PURCHASEID,'REDATE':data.REDATE,'QUOTATIONUP':1,'STATUS': data.STATUS,'CONTRACTNO':data.CONTRACTNO,'SUBCONTRACTNO':data.SUBCONTRACTNO,'CONTRACTDATE':data.CONTRACTDATE,'B2BUSERNAME':data.B2BUSERNAME})"
                            >ລາຍລະອຽດ
                          </b-button>
                        </td>
                      </tr>  
                    </tbody>
                  </table>
                </b-tab-item>
                <b-tab-item label="Invoice">
                  <table class="table is-fullwidth is-narrow is-small">
                    <thead>
                      <tr>
                        <th class="has-text-centered " width="5%">#</th>
                        <th class="has-text-left " width="10%">
                          ສັນຍາເລກທີ/ <br />ເລກທີຍ່ອຍ
                        </th>
                        <th class="has-text-left " width="10%">
                          ວັນທີສັນຍາ
                        </th>
                        <th class="has-text-left " width="15%">
                          ວັນທີສົ່ງສິນຄ້າ
                        </th>
                        <th class="has-text-left " width="15%">
                          ປະເພດ
                        </th>
                        <th class="has-text-left " width="15%">
                          ສິນຄ້າ
                        </th>
                        <th class="has-text-centered " width="15%">
                          ຈັດການ
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(data, index) in contractlist_waitreceipt"
                        :key="data.REDATE"
                      >
                        <td class="has-text-centered">{{ index + 1 }}</td>
                        <td>{{ data.CONTRACTNO }}/ {{ data.SUBCONTRACTNO }}</td>
                        <td>
                          {{ dateFormatter(data.CONTRACTDATE) }}
                        </td>
                        <td>
                          {{ dateFormatter(data.REDATE) }}
                        </td>
                        <td>
                          {{ data.COUNTTYPE }}
                        </td>
                        <td>
                          {{ data.COUNTPRODUCT }} / {{ data.COUNTPRODUCTSUB }}
                        </td>
                        <td class="has-text-centered">
                          <b-button
                            class="btn-group-margin"
                            type="is-info"
                            size="is-small"
                            @click="openContractDateForm({'B2BID':data.B2BID,'PURCHASEID':data.PURCHASEID,'REDATE':data.REDATE,'QUOTATIONUP':1,'STATUS': data.STATUS,'CONTRACTNO':data.CONTRACTNO,'SUBCONTRACTNO':data.SUBCONTRACTNO,'CONTRACTDATE':data.CONTRACTDATE,'B2BUSERNAME':data.B2BUSERNAME})"
                            >ລາຍລະອຽດ
                          </b-button>
                        </td>
                      </tr>  
                    </tbody>
                  </table>
                </b-tab-item>
                <b-tab-item label="Receipt"> 
                  <table class="table is-fullwidth is-narrow is-small">
                    <thead>
                      <tr>
                        <th class="has-text-centered " width="5%">#</th>
                        <th class="has-text-left " width="10%">
                          ສັນຍາເລກທີ/ <br />ເລກທີຍ່ອຍ
                        </th>
                        <th class="has-text-left " width="10%">
                          ວັນທີສັນຍາ
                        </th>
                        <th class="has-text-left " width="15%">
                          ວັນທີສົ່ງສິນຄ້າ
                        </th>
                        <th class="has-text-left " width="15%">
                          ປະເພດ
                        </th>
                        <th class="has-text-left " width="15%">
                          ສິນຄ້າ
                        </th>
                        <th class="has-text-centered " width="15%">
                          ຈັດການ
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(data, index) in contractlist_receipt"
                        :key="data.REDATE"
                      >
                        <td class="has-text-centered">{{ index + 1 }}</td>
                        <td>{{ data.CONTRACTNO }}/ {{ data.SUBCONTRACTNO }}</td>
                        <td>
                          {{ dateFormatter(data.CONTRACTDATE) }}
                        </td>
                        <td>
                          {{ dateFormatter(data.REDATE) }}
                        </td>
                        <td>
                          {{ data.COUNTTYPE }}
                        </td>
                        <td>
                          {{ data.COUNTPRODUCT }} / {{ data.COUNTPRODUCTSUB }}
                        </td>
                        <td class="has-text-centered">
                          <b-button
                            class="btn-group-margin"
                            type="is-info"
                            size="is-small"
                            @click="openContractDateForm({'B2BID':data.B2BID,'PURCHASEID':data.PURCHASEID,'REDATE':data.REDATE,'QUOTATIONUP':1,'STATUS': data.STATUS,'CONTRACTNO':data.CONTRACTNO,'SUBCONTRACTNO':data.SUBCONTRACTNO,'CONTRACTDATE':data.CONTRACTDATE,'B2BUSERNAME':data.B2BUSERNAME})"
                            >ລາຍລະອຽດ
                          </b-button>
                        </td>
                      </tr>  
                    </tbody>
                  </table>
                </b-tab-item>
              </b-tabs>
            </b-field>
          </b-filed>
        </b-tab-item>

        <b-tab-item label="ລາຍລະອຽດ">
          <b-field v-if="b2busername === null">
            <button class="button is-info" @click="gotoB2Blist">
              ເລືອກ B2B
            </button>
          </b-field>
          <b-filed v-else>
            <div class="columns">
              <div class="column">
                <b-field group> 
                  <h3 class="title">
                    {{ b2busername }}, ເລກທີສັນຍາ: {{ selectedcontractno }}/
                    {{ selectedsubcontractno }}  
                    <br><br>
                    <span v-if="contractstatus==1">Prepare</span>
                    <span v-else-if="contractstatus==2">Quotation</span>
                    <span v-else-if="contractstatus==3">Invoice</span>
                    <span v-else-if="contractstatus==4">Receipt</span>
                     
                  </h3>
                </b-field>
              </div>
            </div>
            <b-filed v-if="isContractProductList">
              <b-field group>
                <b-field label="ລາຍການສິນຄ້າໃນສັນຍາ"></b-field>
                <b-field style="margin: 0 10px 0 10px;">
                  <b-button
                    v-if="isContractProductList && contractstatus == 1"
                    class="btn-group-margin"
                    type="is-info"
                    size="is-small"
                    @click="openContractQuotaForm()"
                    >ເປີດຟອມປ້ອນໂຄຕາ
                  </b-button>
                </b-field>
              </b-field>

              <b-tabs v-model="activeSub2Tab" v-if="roleid == 6 || roleid == 7">
                <b-tab-item label="ວັນທີສົ່ງສິນຄ້າ" v-if="quotationup==1" disabled>
                  
                </b-tab-item>
                <b-tab-item label="ວັນທີສົ່ງສິນຄ້າ" v-if="quotationup==0"> 
                  <table class="table is-fullwidth is-narrow is-small">
                    <thead>
                      <tr>
                        <th class="has-text-centered " width="5%">#</th>
                        <th class="has-text-left " width="15%">
                          ວັນທີສົ່ງສິນຄ້າ
                        </th>
                        <th class="has-text-left " width="15%">
                          ປະເພດ
                        </th>
                        <th class="has-text-left " width="15%">
                          ສິນຄ້າ
                        </th>
                        <th class="has-text-centered " width="15%">
                          ສະຖານະ
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(data, index) in contractproductlist"
                        :key="data.REDATE"
                      >
                        <td class="has-text-centered">{{ index + 1 }}</td>
                        <td>
                          {{ dateFormatter(data.REDATE) }}
                        </td>
                        <td>
                          {{ data.COUNTTYPE }}
                        </td>
                        <td>
                          {{ data.COUNTPRODUCT }} / {{ data.COUNTPRODUCTSUB }}
                        </td>
                        <td class="has-text-centered">
                          <b-button
                            class="btn-group-margin"
                            type="is-info"
                            size="is-small"
                            @click="openContractDateForm(data)"
                            >ລາຍລະອຽດ
                          </b-button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-tab-item>
                <b-tab-item label="ລາຍລະອຽດສິນຄ້າ">
                  <div class="columns">
                      <div class="column">
                        ວັນທີສົ່ງສິນຄ້າ: {{ dateFormatter(selectedContractDate) }}
                      </div>
                      <div class="column" style="text-align: right; ">  
                        
                        <b-button  v-if="contractstatus==1"
                          class="btn-group-margin"
                          type="is-primary"
                          size="is-small"
                          @click="
                            changeContractDateStatus(2)
                          "
                          >ຢືນຢັນລາຍການ
                        </b-button>
                        <b-button  v-if="contractstatus==2"
                          class="btn-group-margin"
                          type="is-primary"
                          size="is-small"
                          @click="
                            changeContractDateStatus(3)
                          "
                          >ສ້າງ Invoice
                        </b-button>
                        <b-button  v-if="contractstatus==3"
                          class="btn-group-margin"
                          type="is-primary"
                          size="is-small"
                          @click="
                            changeContractDateStatus(4)
                          "
                          >ຢືນຢັນການຮັບເງິນ (Receipt)
                        </b-button> 
                        <b-button v-if="quotationup > 0" 
                          class="is-small btn-group-margin"
                          type="is-danger"
                          @click="print()" 
                          >ພິມບິນ
                        </b-button>
                      </div>
                  </div>
                    
                  <table class="table is-fullwidth is-narrow is-small">
                    <thead>
                      <tr>
                        <th class="has-text-centered " width="5%">#</th>
                        <th class="has-text-left " width="15%">
                          ປະເພດ
                        </th>
                        <th class="has-text-left " width="15%">
                          ສິນຄ້າ
                        </th>
                        <th class="has-text-centered " width="15%">
                          ຈຳນວນ
                        </th>
                        <th class="has-text-centered " width="15%">
                          ຫົວໜ່ວຍ
                        </th>
                        <th class="has-text-centered " width="15%">
                          ລາຄາ
                        </th>
                        <th class="has-text-centered " width="15%">
                          ລວມເປັນເງິນ
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(data, index) in contractproductdatelist"
                        :key="data.PRODUCTID"
                      >
                        <td class="has-text-centered">{{ index + 1 }}</td>
                        <td>
                          {{ data.TYPENAME }}
                        </td>
                        <td>
                          {{ data.PRODUCTNAME }}
                        </td>
                        <td class="has-text-right">
                          {{ data.B2BAMOUNT | formatNumberLocal}}
                        </td>
                        <td class="has-text-right">
                         {{ data.UNIT }}
                        </td>
                        <td class="has-text-right">
                          {{ data.UNITPRICE | formatNumberLocal}} 
                        </td>
                        <td class="has-text-right"> 
                          {{ data.TOTAL | formatNumberLocal}} 
                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <th colspan="6" class="has-text-centered">
                          ລວມ {{ contractproductdatelist.length | formatNumberLocal }} ລາຍການ 
                        </th>
                        <th class="has-text-right">
                          {{ _.sumBy(contractproductdatelist, i => i["TOTAL"] * 1) | formatNumberLocal }}
                        </th>
                        
                      </tr>
                    </tfoot>
                  </table>
                </b-tab-item>
              </b-tabs>
            </b-filed>
            <b-filed v-if="!isContractProductList">
              <div class="columns">
                <div class="column">
                  <b-field label="ຟອມໂຄຕ້າ"></b-field>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <b-field class="group">
                    <b-field label="ວັນທີ" style="margin-right: 15px;">
                    </b-field>
                    <b-field>
                      <b-datepicker
                        :date-formatter="dateFormatter"
                        v-model="selecteddate"
                        @input="onSelecteddate"
                      >
                      </b-datepicker>
                    </b-field>
                    <b-field style="margin-left:15px;">
                      <b-button
                        v-if="!isContractProductList"
                        class="btn-group-margin"
                        type="is-info"
                        size="is-small"
                        @click="openContractProductList()"
                        >ເບິ່ງສິນຄ້າໃນສັນຍາທັງໝົດ
                      </b-button>
                    </b-field>
                  </b-field>
                </div>
                <div class="column"></div>
              </div>
              <b-tabs v-model="activeSubTab">
                <b-tab-item
                  :label="type.TYPENAME"
                  v-for="type in productType"
                  :key="type.TYPEID"
                >
                  <div class="columns">
                    <div class="column has-text-right">
                      ສິນຄ້າ
                    </div>
                    <div class="column" style="text-align:right;">
                      ຈຳນວນ
                    </div>
                    <div class="column">
                      ຫົວໜ່ວຍ
                    </div>

                    <div class="column"></div>
                    <div class="column"></div>
                    <div class="column"></div>
                  </div>

                  <div :label="type.TYPENAME">
                    <b-filed
                      v-for="product in products"
                      :key="product.PRODUCTID_SUB"
                    >
                      <div
                        class="columns"
                        v-if="type.TYPEID === product.TYPEID"
                      >
                        <div class="column has-text-right">
                          {{ product.PRODUCTNAME_SUB }}
                        </div>
                        <div class="column" style="text-align:right;">
                          <b-field v-if="product.B2BAMOUNT === null">
                            <b-input v-model.trim="product.AMOUNT"> </b-input>
                          </b-field>
                          <b-feild v-else>
                            {{ product.B2BAMOUNT | formatNumberLocal }}
                          </b-feild>
                        </div>
                        <div class="column">
                          <b-field group>
                            <b-field>
                              {{ product.UNIT }}
                            </b-field>
                          </b-field>
                        </div>
                        <div class="column">
                          <b-field
                            v-if="product.B2BSTATUS != 1 && contractstatus == 1"
                          >
                            <b-button
                              class="btn-group-margin"
                              type="is-primary"
                              size="is-small"
                              @click="saveProductAmount()"
                              >ບັນທຶກ
                            </b-button>
                          </b-field>
                          <b-field v-if="contractstatus > 1">
                            ສົ່ງແຜນໄປຜະລິດແລ້ວ
                          </b-field>
                          <b-field
                            v-if="product.B2BSTATUS == 1"
                            style="margin: 0 10px 0 10px;"
                          >
                            <b-button
                              class="btn-group-margin"
                              type="is-warning"
                              size="is-small"
                              @click="unSetProductAmount(product.ID, 0)"
                              >ລ້າງໂຄຕາ
                            </b-button>
                          </b-field>
                        </div>

                        <div class="column"></div>
                        <div class="column"></div>
                      </div>
                    </b-filed>
                  </div>

                  <div class="columns">
                    <div class="column"></div>

                    <div class="column">
                      <b-field group>
                        <b-field>
                          <b-button
                            class="btn-group-margin"
                            type="is-primary"
                            size="is-small"
                            @click="saveProductAmount()"
                            >ບັນທຶກ
                          </b-button>
                        </b-field>
                        <b-field>
                          <b-button
                            class="btn-group-margin"
                            type="is-warning"
                            size="is-small"
                            @click="unSetProductsAmount(type.TYPEID)"
                            >ລ້າງໂຄຕາ
                          </b-button>
                        </b-field>
                      </b-field>
                    </div>

                    <div class="column"></div>
                    <div class="column"></div>
                  </div>
                </b-tab-item>
              </b-tabs>
            </b-filed>
          </b-filed>
        </b-tab-item>
      </b-tabs>
    </div>
    <div class="contain print-only page-break">
      <div class="contain">
        <div class="columns">
          <div class="column">
            <div style="margin-top: 0px; text-align: center;">
              <div style="font-size: 24px; font-weight: bold">
                ໃບບິນເກັບເງິນ
              </div>
              
            </div>
            <div style="background-color: red; padding: 0 0 0 0; margin: 0 0 0 0 ;" >
              <img
                  class="image-area"
                  style="width: 70px;"
                  :src="getImgUrl('logo/agrilaologo.png')"
                  alt="Placeholder image"
                />
            </div>
            <div class="columns">
              <div class="column" style="">
                <div style="font-size: 12px;">
                  Agrilao Innovation Ordinary Partnertship 
                </div>
                <div style="font-size: 12px;">
                  Address: Dongdok-Sikuert Road,
                </div>
                <div style="font-size: 12px; padding-left: 50px;">
                  Sikhottabong Distirct, Vientiane Capital, Laos
                </div>
                <div style="font-size: 12px;">
                  Contact No: +85620 55333483, +85620 28040508
                </div>
                <div style="font-size: 12px;">
                  Email: argilao.lpdr@gmail.com
                </div>
              </div>
              <div class="column" style="text-align: right;">
                 <div>
                  Date: ................
                 </div>
                 <div>
                  No: .................
                 </div>
              </div>
            </div>
            
            <div>
              
            </div>
            <table class="table is-fullwidth is-narrow is-small" >
              <thead>
                <tr >
                  <th class="has-text-centered set-border" width="5%" >ລ/ດ</th>
                  <th class="has-text-centered set-border" width="15%">
                    ປະເພດ
                  </th>
                  <th class="has-text-centered set-border" width="15%">
                    ສິນຄ້າ
                  </th>
                  <th class="has-text-centered set-border" width="15%">
                    ຈຳນວນ
                  </th>
                  <th class="has-text-centered set-border" width="15%">
                    ຫົວໜ່ວຍ
                  </th>
                  <th class="has-text-centered set-border" width="15%">
                    ລາຄາ
                  </th>
                  <th class="has-text-centered set-border" width="15%">
                    ລວມເປັນເງິນ
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in contractproductdatelist"
                  :key="data.PRODUCTID"
                >
                  <td class="has-text-centered set-border">{{ index + 1 }}</td>
                  <td class="set-border">
                    {{ data.TYPENAME }}
                  </td>
                  <td  class="set-border">
                    {{ data.PRODUCTNAME }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.B2BAMOUNT | formatNumberLocal}}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.UNIT }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.UNITPRICE | formatNumberLocal}} 
                  </td>
                  <td class="has-text-right set-border"> 
                    {{ data.TOTAL | formatNumberLocal}} 
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th colspan="6" class="has-text-right set-border">
                    ລວມ {{ contractproductdatelist.length | formatNumberLocal }} ລາຍການ 
                  </th>
                  <th class="has-text-right set-border">
                    {{ _.sumBy(contractproductdatelist, i => i["TOTAL"] * 1) | formatNumberLocal }}
                  </th>
                  
                </tr>
              </tfoot>
            </table>
            
            <div class="columns">
              <div class="column">
                <div style="font-weight: bold; font-size: 16px;">
                  Confirm and Accept by Customer
                </div>
                <div style="font-size: 12px;">
                 .................................................................................
                </div>
                <div style="font-size: 12px; ">
                
                  (Name/ Signature/ Company Stamp)
                </div>
                
              </div>
              <div class="column" style="text-align: centter; font-weight: bold; font-size: 16px;">
                 <div >
                  Agrilao Inovation Ordinary Partnership
                 </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
import Multiselect from "vue-multiselect";
import moment from "moment";

export default {
  components: { Multiselect },
  props: ["MONTH"],
  data() {
    return {
      roleid: null,
      userName: null,

      activeb2b: [],
      // inactivemarkets: [],
      b2buserid: null,
      b2busername: null,

      activeTab: 0,

      saveAction: true,
      updateAction: false,
      adddataform: true,
      updatedataform: false,

      activeSubTab: 0,
      productType: [],
      products: [],
      productamount: [],
      selecteddate: null,

      activeSub2Tab: 0,

      quotaltoproduction: [],
      activeQuotaSubTab: 0,
      quotadate: null,
      quotadatetypes: null,
      quotadateproducts: null,
      selectedquotaddate: null,
      contractid: null,
      contractno: null,
      subcontractno: null,
      selectedcontractno: null,
      selectedsubcontractno: null,
      countryList: [],
      SelectedCountry: null,
      ProvinceList: [],
      SelectedProvince: null,
      district: null,
      village: null,
      contractstatus: null,
      contractdate: null,
      contractdetail: null,
      contractlist_waittoapprove: [],
      contractlist_waitinvoice: [],
      contractlist_waitreceipt: [],
      contractlist_receipt: [],
      isContractProductList: false,
      contractproductlist: [],

      activeQuotaProgressTab: 0,

      DppProvinceList: [],
      SelectedDppProvince: null,
      stockList: [],
      selectedStock: null,

      selectedProvinceid: null,
      selectedBranchid: null,
      selectedContractDate: null,
      selectedContractID: null,
      selectedPurchaseID: null,
      contractproductdatelist: [],

      photopath:
        process.env.NODE_ENV === "production"
          ? "https://agrilao.com/manger/api/uploads/"
          : "http://localhost/agrilao-manager/api/uploads/",

      quotationup: 0,
      contractProgress: 0,
    };
  },
  methods: {
    changeContractDateStatus(purchaseStatus){
      var params = {
        purchaseid: this.selectedPurchaseID,
        status: purchaseStatus,
        username: this.username,
      };

      console.log("puchaseid: " + JSON.stringify(params))

      RestAPI.changeContractDateStatus(params)
        .then(() => {        
          this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
          this.getContractByB2bUser(this.b2busername);

        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },
    openContractDateForm(data) {
      this.selectedPurchaseID = data.PURCHASEID
      this.selectedContractID = data.B2BID;
      this.selectedContractDate = data.REDATE;
      this.activeSub2Tab = 1;
      if(data.QUOTATIONUP){
        this.activeTab = 2;
        this.quotationup = 1;
        this.contractid =  data.B2BID;
        this.selectedcontractno = data.CONTRACTNO;
        this.selectedsubcontractno = data.SUBCONTRACTNO;
        this.contractdate = data.CONTRACTDATE;
        this.b2busername = data.B2BUSERNAME;
        this.isContractProductList = true;
        this.contractstatus = data.STATUS;
        // this.contractstatus = STATUS;
      }

      console.log("data: " + JSON.stringify(data));

      RestAPI.getContractDateProductList(
        this.selectedContractID,
        1,
        this.selectedContractDate
      )
        .then((res) => {
          this.contractproductdatelist = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getCountry() {
      RestAPI.getCountry()
        .then((res) => {
          // console.log("con: "+ JSON.stringify(res.data))
          this.countryList = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    saveContract() {
      if (
        this.contractno === null ||
        this.subcontractno === null ||
        this.selecteddate === null ||
        this.SelectedCountry === null ||
        this.SelectedProvince === null ||
        this.district === null ||
        this.village === null
      ) {
        this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
      } else {
        var params = {
          b2busername: this.b2busername,
          contracttype: 1, //purchase
          contractno: this.contractno,
          subcontractno: this.subcontractno,
          contractdate: this.dateFormatterYYYYMMDD(this.selecteddate),
          provinceid: this.SelectedProvince.ID,
          district: this.district,
          village: this.village,
          detail: this.contractdetail,
          dppprovinceid: null,
          ddppbranchid: null,
          stockid: null,
          username: this.username,
        };
        // console.log("params: " + JSON.stringify(params));
        RestAPI.saveContract(params)
          .then((res) => {
            // console.log("data: " + JSON.stringify(res.data))
            if (res.data == "duplicate b2bcontract") {
              this.$swal("ສັນຊາຊໍ້ຳ", "-", "error");
              return false;
            }

            this.getContractByB2bUser(this.b2busername);
            this.$swal("ບັນທຶກສັນຍາ ສຳເລັດ!", "", "success");
            this.saveAction = true;
            this.updateAction = false;
            this.selecteddate = null;
            this.contractno = null;
            this.subcontractno = null;
            this.detail = null;
            this.selectedCountry = null;
            this.SelectedProvince = null;
            this.district = null;
            this.village = null;
            this.SelectedDppProvince = null;
            this.selectedStock = null;
            // console.log(res);
          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });
      }
    }, 
    getContractByB2bUser(b2busername) {
      RestAPI.getContractByB2bUser(b2busername, 1)
        .then((res) => {
          // console.log("list:"+ JSON.stringify(res.data))
          this.contractlist_waittoapprove = res.data.waittoapprove;
          this.contractlist_waitinvoice = res.data.waitinvoice;
          this.contractlist_waitreceipt = res.data.waitreceipt;
          this.contractlist_receipt = res.data.receipt;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getB2bUser() {
      RestAPI.getDASMB2bUser(this.username, 1)
        .then((res) => {
          // console.log("list:"+ JSON.stringify(res.data))
          this.activeb2b = res.data;
          // this.inactivemarkets = res.data.inactivemarkets;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getProductType() {
      RestAPI.getProductType()
        .then((res) => {
          this.productType = res.data.activeProductType;
          // console.log("prodcuttype: " + JSON.stringify(this.productType));
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getContractProducts() {
      RestAPI.getContractProductsByType(
        this.contractid,
        this.dateFormatterYYYYMMDD(this.selecteddate),
        1
      )
        .then((res) => {
          this.products = res.data;
          // console.log("products: " + JSON.stringify(this.products));
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    contractform(B2BUSERID, B2BUSERNAME, ISNOTMOVE = null) {
      if (ISNOTMOVE != 1) {
        this.activeTab = 1;
      }
      this.activeQuotaProgressTab = 0;

      this.b2buserid = B2BUSERID;
      this.b2busername = B2BUSERNAME;
      this.getContractByB2bUser(B2BUSERNAME);
    },
    quotadetailform(
      CONTRACTID,
      B2BUSERNAME,
      CONTRACTNO,
      SUBCONTRACTNO,
      CONTRACTDATE,
      SELECTEDDPPBRANCHID,
      SELECTEDDPPPROVINCE,
      STATUS
    ) {
      this.quotationup = 0;
      this.contractproductdatelist = [];
      this.selectedContractDate = null;
      this.selectedContractID = null;
      this.contractproductlist = [];
      this.activeTab = 2;
      this.contractid = CONTRACTID;
      this.selectedcontractno = CONTRACTNO;
      this.selectedsubcontractno = SUBCONTRACTNO;
      this.contractdate = CONTRACTDATE;
      this.b2busername = B2BUSERNAME;
      this.selectedBranchid = SELECTEDDPPBRANCHID;
      this.selectedProvinceid = SELECTEDDPPPROVINCE;
      this.contractstatus = STATUS;
      this.getContractProducts();
      this.openContractProductList();
      this.activeSub2Tab = 0;
      console.log("STATUS: " + STATUS);
      // console.log("redate: " + this.dateFormatterYYYYMMDD(this.selecteddate));
    },
    gotoB2Blist() {
      this.activeTab = 0;
    },
    // quotaToProduction(ID, MARTKETNAME){
    //   this.activeTab = 2;
    //   this.marketid = ID;
    //   this.marketname = MARTKETNAME;

    //   RestAPI.getProductToProduction(this.marketid)
    //     .then(res => {
    //       this.quotaltoproduction = res.data;
    //     })
    //     .catch(error => {
    //       console.log(error);
    //       this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
    //     });
    // },
    gotoquotadate() {
      this.activeQuotaSubTab = 0;
    },

    onSelecteddate() {
      this.getContractProducts();
      // this.formdate = this.dateFormatterYYYYMMDD(this.selecteddate);
      // console.log(this.formdate);
    },
    // onSelectedquotaldate() {
    //   this.quotadatededtailtab(this.dateFormatterYYYYMMDD(this.selectedquotaddate))
    //   console.log("this.dateFormatterYYYYMMDD(this.selectedquotaddate): " + this.dateFormatterYYYYMMDD(this.selectedquotaddate))
    // },
    saveProductAmount() {
      //  console.log("this.formdate: "+ this.formdate)
      if (this.selecteddate == null) {
        this.$swal("ກະລູນາປ້ອນຈຳນວນວັນທີ", "", "error");
      }
      var params = {
        redate: this.dateFormatterYYYYMMDD(this.selecteddate),
        b2busername: this.b2busername,
        contractid: this.contractid,
        contractno: this.selectedcontractno,
        products: this.products,
        contracttype: 1,
        username: this.username,
      };

      console.log("params: ", JSON.stringify(params));

      RestAPI.saveB2BQuotaProductAmount(params)
        .then((res) => {
          console.log("res: " + JSON.stringify(res.data));

          if (res.data.result > 0) {
            this.$swal("ບັນທືກ ສຳເລັດ!", "", "success");
          } else {
            this.$swal("ກະລຸນາປ້ອນຢ່າງໜ້ອຍ 1 ລາຍການ!", "", "warning");
          }

          this.getContractProducts();
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },
    unSetProductsAmount(type) {
      //  console.log("this.formdate: "+ this.formdate)
      var params = {
        redate: this.dateFormatterYYYYMMDD(this.selecteddate),
        contractid: this.contractid,
        typeid: type,
        username: this.username,
      };

      RestAPI.unSetContractProductsAmount(params)
        .then(() => {
          this.$swal("ລ້າງໂຄຕ້າ ສຳເລັດ!", "", "success");
          this.getContractProducts();
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },
    unSetProductAmount(ID, type) {
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          //  console.log("this.formdate: "+ this.formdate)
          var params = {
            detailid: ID,
            username: this.username,
          };

          // console.log("par: " + JSON.stringify(params));

          RestAPI.unSetContractPurchaseProductAmount(params)
            .then(() => {
              this.$swal("ລ້າງໂຄຕ້າ ສຳເລັດ!", "", "success");
              if (type == 1) {
                this.openContractProductList();
              }

              this.getContractProducts();
            })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },
    openContractProductList() {
      this.isContractProductList = true;
      // console.log("this.contractid: " + this.contractid)
      RestAPI.getContractProductListByContractType(this.contractid, 1)
        .then((res) => {
          this.contractproductlist = res.data;
          // console.log("products: " + JSON.stringify(res.data));
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    openContractQuotaForm() {
      this.isContractProductList = false;
    },
    confirmContractProducts() {
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            contractid: this.contractid,
            branchid: this.selectedBranchid,
            provinceid: this.selectedProvinceid,
            username: this.username,
          };
          RestAPI.confirmContractProducts(params)
            .then(() => {
              this.$swal("ຢືນຢັນລາຍການສິນຄ້າໃນສັນຍາ ສຳເລັດ!", "", "success");
              this.openContractProductList();
              this.contractstatus = 2;
              this.contractform(this.b2buserid, this.b2busername, 1);
            })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },
    cancelConfirmContractProducts() {
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            contractid: this.contractid,
            username: this.username,
          };
          RestAPI.cancelConfirmContractProducts(params)
            .then(() => {
              this.$swal(
                "ຍົກເລີກການຢືນຢັນລາຍການສິນຄ້າ ໃນສັນຍາ ສຳເລັດ!",
                "",
                "success"
              );
              this.openContractProductList();
              this.contractstatus = 1;
              this.contractform(this.b2buserid, this.b2busername, 1);
            })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },

    onCountrySelected() {
      RestAPI.getProvincebyCountry(this.SelectedCountry.ID)
        .then((res) => {
          // console.log("country selected...")
          this.ProvinceList = res.data;
          this.SelectedProvince = null;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getDppProvince() {
      RestAPI.getDppProvince()
        .then((res) => {
          // console.log("country selected...")
          this.DppProvinceList = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getStockList() {
      RestAPI.getStockList(this.username)
        .then((res) => {
          console.log("getStockList : " + JSON.stringify(res.data));
          this.stockList = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getProvince() {
      RestAPI.getProvincebyCountry(this.selectedCountry.ID)
        .then((res) => {
          // console.log("country selected...")
          this.provinceList = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },

    print() {
      window.print();
    },
    getImgUrl(photoname) {
      var photopreview = photoname
        ? this.photopath + photoname
        : this.photopath + "unknown.png";
      return photopreview;
    },
  },
  mounted() {
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;
    this.getB2bUser();
    this.getCountry();
    this.getProductType();
    this.selecteddate = new Date();
    this.selectedquotaddate = new Date();
    this.formdate = new Date();
    this.getDppProvince();
    this.getStockList();
  },
  computed: {
    formdatestr() {
      return new moment(this.formdate).format("YYYY-MM-DD");
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.asterisk {
  color: red;
}

.set-border{
  border: 1px solid #ddd;
}

@media print {
    table {
      border: 1px solid #ddd;
    }
  }
</style>
